import { FC } from "react";
import { capitalizeFirstLetter } from "../../../../utils";
import { RecommendedSizeType } from "../../../../types/result";
import { findBrandByDomain } from "../../../../configs/configLoader";
import SizeSelectorsVB from "../SizeSelectorsVB";
import { resultScreenUI } from "../../../../configs";

import "./index.css";
interface IPropsSizeSelectorsComponent {
  sizeLabelRank0: RecommendedSizeType | null | undefined;
  sizeLabelRank1: RecommendedSizeType | null | undefined;
  sizeLabelRank2: RecommendedSizeType | null | undefined;
  selectedVariant: string;
  setSelectedVariant: React.Dispatch<React.SetStateAction<string>>;
  firstSelectorStyles: any;
  secondSelectorStyles: any;
  thirdSelectorStyles: any;
  fit_feedbacks: string[];
  selectedSize: RecommendedSizeType | null;
  isSizeUnavailable: boolean;
  recommendedSize?: RecommendedSizeType[];
  sizesData: (RecommendedSizeType | null)[];
}

const SizeSelectorsComponent: FC<IPropsSizeSelectorsComponent> = ({
  sizeLabelRank0,
  sizeLabelRank1,
  sizeLabelRank2,
  selectedVariant,
  setSelectedVariant,
  firstSelectorStyles,
  secondSelectorStyles,
  thirdSelectorStyles,
  fit_feedbacks,
  selectedSize,
  isSizeUnavailable,
  recommendedSize = [],
  sizesData,
}) => {
  const brandDefined = findBrandByDomain();

  const isSudExpress = brandDefined?.name === "Sud Express";
  const isVB = brandDefined?.name === "Victoria Beckham";
  const isGivenchy = brandDefined?.name === "Givenchy";

  const isCustomResultDesign = isVB || isGivenchy;

  const styleMap = [
    firstSelectorStyles,
    secondSelectorStyles,
    thirdSelectorStyles,
  ];

  if (isSudExpress) {
    const sortedRec = [...recommendedSize].sort(
      (a, b) => (a.label_rank ?? 1) - (b.label_rank ?? 1),
    );

    return sortedRec?.length > 1 ? (
      <div className="sizes-menu">
        {sortedRec.map((item, index) => {
          const activeIndex = sortedRec?.length < 3 ? index + 1 : index;

          const style =
            styleMap[activeIndex] || styleMap[styleMap.length - 1] || {};

          return (
            <div
              key={item?.variant_id || index}
              tabIndex={0}
              className={`menu-item ${
                selectedVariant === item?.variant_id ? "active" : ""
              }`}
              onClick={() => item && setSelectedVariant(activeIndex.toString())}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  item && setSelectedVariant(activeIndex.toString());
                }
              }}
              style={{
                ...style,
                width: `calc(100% / ${sortedRec.length})`,
                cursor: "pointer",
                textTransform:
                  style?.textTransform === "capitalize"
                    ? "none"
                    : style?.textTransform,
                letterSpacing: (resultScreenUI.Description as any)
                  ?.letterSpacing,
              }}
            >
              <p
                style={{
                  letterSpacing: (resultScreenUI.Description as any)
                    ?.letterSpacing,
                }}
              >
                {item &&
                  (item?.variant_id && style?.textTransform !== "capitalize"
                    ? fit_feedbacks[index]
                    : capitalizeFirstLetter(fit_feedbacks[index]))}
              </p>
            </div>
          );
        })}
      </div>
    ) : null;
  }

  if (isCustomResultDesign) {
    return (
      <SizeSelectorsVB
        sizeLabelRank0={sizeLabelRank0}
        sizeLabelRank1={sizeLabelRank1}
        sizeLabelRank2={sizeLabelRank2}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        fit_feedbacks={fit_feedbacks}
        selectedSize={selectedSize}
        isSizeUnavailable={isSizeUnavailable}
      />
    );
  }

  return (
    <div className="sizes-menu">
      {sizesData?.map((size, index) => {
        const style = styleMap[index];

        return (
          <div
            key={index}
            tabIndex={0}
            aria-label={
              size
                ? size?.variant_id && style?.textTransform !== "capitalize"
                  ? fit_feedbacks[index]
                  : capitalizeFirstLetter(fit_feedbacks[index])
                : ""
            }
            className={`menu-item ${
              selectedVariant === index.toString() ? "active" : ""
            }`}
            onClick={() => size && setSelectedVariant(index.toString())}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") {
                size && setSelectedVariant(index.toString());
              }
            }}
            style={{
              ...style,
              cursor: size ? "pointer" : "default",
              textTransform:
                style?.textTransform === "capitalize"
                  ? "none"
                  : style?.textTransform,
              width: `calc(100% / ${sizesData.length})`,
              letterSpacing: (resultScreenUI.Description as any)?.letterSpacing,
            }}
          >
            <p
              style={{
                letterSpacing: (resultScreenUI.Description as any)
                  ?.letterSpacing,
              }}
            >
              {size
                ? size?.variant_id && style?.textTransform !== "capitalize"
                  ? fit_feedbacks[index]
                  : capitalizeFirstLetter(fit_feedbacks[index])
                : ""}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default SizeSelectorsComponent;
